.container {
  /* CSS variable also used for positioning of hero img-wrapper on collection pages */
  --padding-block: calc(var(--rds-spacing--8) + var(--rds-fluid-spacing--0-8));
  --section-padding-top: var(--padding-block);
  --section-padding-bottom: var(--padding-block);

  padding: var(--section-padding-top) 0 var(--section-padding-bottom);
  overflow: hidden;
}

.light {
  /* RiksTv gets fallback until css variables are in place */
  background-color: var(--strim-white, #fff);
}

.transparent {
  background-color: transparent;
}

.dark {
  /* RiksTv gets fallback until css variables are in place */
  background-color: var(--strim-standup-green-10, #fff);
}

.veryDark {
  /* RiksTv gets fallback until css variables are in place */
  background-color: var(--strim-fantasy-green, #fff);
}

.fullHeight {
  min-height: 100vh;
}

.noPaddingTop {
  --section-padding-top: 0;
}

.noPaddingBottom {
  --section-padding-bottom: 0;
}
